<template>
  <div class="survey-view">
    <div class="row">
      <div class="col-xs-12 col-lg-8">
        <customer-card v-loading="customerLoading" :customer="customer" :show-edit-button="false"></customer-card>
      </div>
      <div class="col-xs-12 col-lg-4">
        <customer-image-card
          :has-image="true"
          :customer="customer" v-loading="customerLoading" :show-edit-button="false"> </customer-image-card>
      </div>
    </div>
    <div class="card">
      <div class="card-header">
        <h4 class="card-title"><i class="ti-user"></i> Pesquisa</h4>
      </div>
      <div v-loading="surveyLoading" class="card-content row">
        <div class="col-lg-6 col-xs-12">
          <survey-view-general :survey="survey"></survey-view-general>
        </div>
        <div class="col-lg-6 col-xs-12">
          <survey-view-detail :survey="survey"></survey-view-detail>
        </div>
        <div class="col-xs-12">
          <survey-view-images :survey="survey"></survey-view-images>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import CustomerCard from 'src/pages/Customers/CustomerCard'
import CustomerImageCard from 'src/pages/Customers/CustomerImageCard'
import SurveyViewDetail from 'src/pages/Surveys/SurveyViewDetail'
import SurveyViewGeneral from 'src/pages/Surveys/SurveyViewGeneral'
import SurveyViewImages from 'src/pages/Surveys/SurveyViewImages'
import { mapActions } from 'vuex'
export default {
  name: 'survey-view',

  components: {
    CustomerCard,
    CustomerImageCard,
    SurveyViewDetail,
    SurveyViewGeneral,
    SurveyViewImages
  },

  computed: {
    eventId () {
      return this.$route.params.id
    },

    customerId () {
      return this.$route.params.customerId
    },

    customerLoading: {
      get () {
        return this.$store.state.customers.loading
      }
    },

    surveyLoading: {
      get () {
        return this.$store.state.surveys.loading
      }
    },

    survey: {
      get () {
        let survey = this.$store.state.surveys.all.find(item => {
          return item.customer._id === this.customerId
        })

        return !survey ? {} : survey
      }
    },

    customer: {
      get () {
        return this.$store.state.customers.one
      }
    }
  },

  methods: {
    ...mapActions('customers', {
      fetchCustomer: 'fetchOne'
    }),

    ...mapActions('surveys', {
      fetchSurveys: 'fetchAll'
    })
  },

  mounted () {
    this.fetchCustomer({ docId: this.customerId })
    this.fetchSurveys({ where: [ { 'event._id': this.eventId } ] })
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/Surveys/SurveyView.vue